import { ValueChange } from './ValueChange';

export interface IHistoricListing {
    MlsNo: string;
    ListStatus: number;
    ListStatusLabel: string;
    ListPriceOrig: number;
    ListPriceLast: number;
    ListDate: string; // "\/Date(1477267200000)\/",
    ListDateStr: string;
    InactiveDate: string; // "\/Date(1479427200000)\/",
    InactiveDateStr: string;
    DOM: number;
    ValueChanges: ValueChange[];
}

export class HistoricListing implements IHistoricListing {
    public MlsNo: string;
    public ListStatus: number;
    public ListStatusLabel: string;
    public ListPriceOrig: number;
    public ListPriceLast: number;
    public ListDate: string;
    public ListDateStr: string;
    public InactiveDate: string;
    public InactiveDateStr: string;
    public DOM: number;
    public ValueChanges: ValueChange[] = [];
    constructor(
        historicObject: any,
    ) {
        this.MlsNo = historicObject.mlsNo;
        this.ListStatus = historicObject.listStatus;
        this.ListStatusLabel = historicObject.listStatusLabel;
        this.ListPriceOrig = historicObject.listPriceOrig;
        this.ListPriceLast = historicObject.listPriceLast;
        this.ListDate = historicObject.listDate;
        this.ListDateStr = historicObject.listDateStr;
        this.InactiveDate = historicObject.inactiveDate;
        this.InactiveDateStr = historicObject.inactiveDateStr;
        this.DOM = historicObject.dom;
        if (historicObject.valueChanges && historicObject.valueChanges.length) {
            this.ValueChanges = historicObject.valueChanges.map((historicObj: any) => new ValueChange(historicObj));
        }
    }
}
